// @flow

import type {Action} from '../../types'
import type {SessionState} from '../types'
import type {SetLoadingPayload} from '../actions/setLoading'

export function setLoadingReducer(state: SessionState, action: Action<SetLoadingPayload>): SessionState {

  return {
    ...state,
    isLoading: action.payload.isLoading,
  }
}
